import React from "react";
import NavItem from "./NavItem";
class NavItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        {
          id: 0,
          name: "Home"
        },
        {
          id: 1,
          name: "About"
        },
        {
          id: 2,
          name: "Experience"
        },
        {
          id: 6,
          name: "Contact"
        }
      ]
    };
  }
  render() {
    return (
      <ul className="navbar-nav ml-auto">
        {this.state.navItems.map(nav => (
          <NavItem key={nav.id} navId={nav.id} navName={nav.name} />
        ))}
      </ul>
    );
  }
}

export default NavItems;
